export type AppEvent = 'UPDATE_ADMIN_REQUEST_COUNT' | 'UPDATE_SIGNATURE_REQUEST_COUNT' | 'UPDATE_EMPLOYEE_TASK_COUNT';

export const AppEvents = {
  // Publish a same-tab application event.
  emit: (event: AppEvent) => {
    const customEvent = new CustomEvent(event);
    window.dispatchEvent(customEvent);
  },
  // Subscribe to a same-tab application event and return its cleanup function.
  subscribe: (event: AppEvent, callback: () => void) => {
    window.addEventListener(event, callback);
    return () => window.removeEventListener(event, callback);
  }
};
